import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import CrossArrow from '../assets/images/svg/cross-arrow.svg'
import { getApiUrl } from '../env'

interface BlogPost {
    id: number;
    title: string;
    slug: string;
    excerpt: string;
    content: string;
    coverImageUrl: string | null;
    category: string | null;
    publishedAt: string;
}

const API_BASE = getApiUrl();

const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString('pl-PL', { day: '2-digit', month: 'long', year: 'numeric' });

const imgSrc = (url: string) =>
    url.startsWith('http') ? url : `${API_BASE}${url}`;

const BlogDetail: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const [post, setPost] = useState<BlogPost | null>(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        if (!slug) return;
        setLoading(true);
        fetch(`${API_BASE}/api/blog/${slug}`)
            .then(r => {
                if (r.status === 404) { setNotFound(true); return null; }
                return r.json();
            })
            .then(data => { if (data) setPost(data); })
            .catch(() => setNotFound(true))
            .finally(() => setLoading(false));
    }, [slug]);

    if (loading) return (
        <section className="blog-section">
            <div className="container" style={{ padding: '4rem 0', textAlign: 'center' }}>Ładowanie...</div>
        </section>
    );

    if (notFound || !post) return (
        <section className="blog-section">
            <div className="container" style={{ padding: '4rem 0', textAlign: 'center' }}>
                <h2>Wpis nie znaleziony.</h2>
                <Link to="/OurBlog">← Wróć do bloga</Link>
            </div>
        </section>
    );

    return (
        <>
            <section className="heroSection">
                <div className="container">
                    <h1 className="img-header-text fade_down">{post.title}</h1>
                    <div className="breadcrumb-group fade_up">
                        <Link to="/">HOME / </Link>
                        <Link to="/OurBlog"> Blog / </Link>
                        <span>{post.title}</span>
                    </div>
                </div>
            </section>

            <section className="blog-section">
                <div className="container">
                    <div className="row blog-two-grid-row">
                        <div className="col-xxl-8 col-xl-8 col-lg-8">
                            {post.coverImageUrl && (
                                <img
                                    className="single-blog-img1"
                                    src={imgSrc(post.coverImageUrl)}
                                    alt={post.title}
                                />
                            )}
                            <div className="tag-date border-bottom-0">
                                {post.category && (
                                    <div className="tag-date-sub">
                                        <p>{post.category}</p>
                                    </div>
                                )}
                                <div className="tag-date-sub">
                                    <p>{formatDate(post.publishedAt)}</p>
                                </div>
                            </div>

                            <div className="blog-markdown-content" style={{ lineHeight: 1.8 }}>
                                <ReactMarkdown>{post.content}</ReactMarkdown>
                            </div>

                            <div style={{ marginTop: '2rem' }}>
                                <Link to="/OurBlog" className="btn-quote">
                                    ← Wróć do bloga
                                    <img src={CrossArrow} alt="cross-arrow" />
                                </Link>
                            </div>
                        </div>

                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-8">
                            <div className="adds-details-main" style={{ marginTop: 0 }}>
                                <h3>Zamów sprzątanie</h3>
                                <Link to="/Contact" className="btn-quote">Skontaktuj się
                                    <img src={CrossArrow} alt="cross-arrow" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default BlogDetail;
